import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { LIST_TAB_SHOP } from "../../constants/shop";
import { Inventory } from "@onmo/graphql/graphql";

interface IInventoriesSlice {
  activeTab: string;
  openingInventory: Inventory | undefined;
}

const initialState = {
  activeTab: LIST_TAB_SHOP[0],
  openingInventory: undefined,
} as IInventoriesSlice;

export const inventoriesSlice = createSlice({
  name: "inventories",
  initialState: initialState,
  reducers: {
    updateActiveTab: (state, action: PayloadAction<{ activeTab: string }>) => {
      state.activeTab = action.payload.activeTab;
    },
    updateOpeningInventory: (
      state,
      action: PayloadAction<{ openingInventory?: Inventory }>,
    ) => {
      state.openingInventory = action.payload.openingInventory;
    },
  },
});

// Action creators are generated for each case reducer function
export const { updateActiveTab, updateOpeningInventory } =
  inventoriesSlice.actions;

export default inventoriesSlice.reducer;
